{
  "firmwareFilterBar": {
    "label": "すべて",
    "label2": "更新可",
    "placeholder": "カメラ名、エリア名で検索",
    "label3": "ステータス"
  },
  "firmwareTable": {
    "label": "カメラ名",
    "label2": "エリア名",
    "label3": "バージョン",
    "label4": "更新日",
    "label5": "ステータス",
    "text": "更新待ちのカメラはありません",
    "button": "すべてのカメラを見る"
  },
  "useFirmwareViewState": {
    "text": "旧バージョン"
  },
  "firmware": {
    "enqueueSnackbar": "ファームウェアアップデートを開始しました",
    "enqueueSnackbar2": "ファームウェアアップデートの設定に失敗しました",
    "title": "ファームウェア管理",
    "text": "非対応",
    "text4": "アップデート実行待ち",
    "text5": "アップデート中",
    "text6": "失敗",
    "text7": "不明",
    "text8": "未定",
    "text9": "最新",
    "text10": "更新可"
  }
}
